export default __webpack_public_path__ + "static/media/ghost_color.56126c9c.png";